import { render, staticRenderFns } from "./GExamList.vue?vue&type=template&id=d0a0424e&scoped=true&"
import script from "./GExamList.vue?vue&type=script&lang=ts&"
export * from "./GExamList.vue?vue&type=script&lang=ts&"
import style0 from "./GExamList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GExamList.vue?vue&type=style&index=1&id=d0a0424e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a0424e",
  null
  
)

export default component.exports